import {
  deleteAccount
} from '../api/maracana';

import {
  updateMe
} from '../api/bernabeu';

import {
  verifyLogged
} from 'app/services/auth';

import {
  notifySuccess
} from "./notify";

// import { getLocation } from '@services/location';

import {
  profileSlice,
  callTypes
} from "../../redux/reducers/profileSlice";

const { actions } = profileSlice;

const requestDeleteAccount = (value) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  deleteAccount({
    should_delete: value,
  }).then(response => {
    dispatch(actions.profileFetched());
    dispatch(verifyLogged(false, false));
    notifySuccess('Solicitação realizada', 'requestDeleteAccount')
  }).catch((error) => {
    console.log('requestDeleteAccount falhou:');
    dispatch(actions.profileFetched());
    console.log({error});
  });
}

const updateDocument = (document: any) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    let params = {
      document: document,
    };

    updateMe(params).then(response => {
      dispatch(actions.profileFetched());

      resolve(response);
    }).catch((error) => {
      console.log('updateDocument falhou:');
      console.log({error});

      dispatch(actions.profileFetched());

      reject(error.response.data.message);
    });
  });
}

export {
//   setStatus,
//   updateSkills,
//   updateLocation,
//   updateShowPhone,
  requestDeleteAccount,
  updateDocument,
}